import React ,{useState}from "react";
import { useSelector } from "react-redux";
//import { updateUserData } from "../../../store/actions/User";
import "./LiveClass.css";
import { useDispatch } from "react-redux";
import {Link, useRouteMatch,Switch, Route } from "react-router-dom";
import Loading from "../Loading/Loading";

const LiveClass=()=>{


   
    const localToken= localStorage.getItem("profile");
    const token = useSelector((state)=>state?.user?.user?.token);
   
   
    const [loader , setLoader] =useState({status:false});
  // const {category} = useParams();
  const {url,path} =useRouteMatch();
  const dispatch = useDispatch();
    return <>
    {(token===localToken&&token&&localToken)?
<>
<div className=" ">

        {<Loading Load={loader?.status}/>}
        <div  className="live-class-backdrop"><div  className="live-class-card"><div  className="blank"> </div>
  <div  className="live-class-card-outer"><div  className="live-class-inner">
  <div  className="live-class-left ">
      <div className="live-class-start-info">
      <div  className="live-class-start-info-top ">
     </div><div   className="live-class-start-info-middle ">
     <div></div><div className="">
     <div className="live-class-user-profile"></div>
     <div className="user-name-live">KG</div>
        </div><div></div>
     </div>
     <div  className=" ">
     <div  className="live-class-start-info-bottom ">
     <div className="live-class-start-column">
     <div className="live-class-start-button-red"></div>
     
     </div><div className="live-class-start-column">
     <div className="live-class-start-button-red"></div>
     
     </div><div className="live-class-start-column">
     <div className="live-class-start-button-red"></div>
    
     </div>
       
     </div><div  className="live-class-start-info-bottom ">
     <div className="live-class-start-column">
     <h4>Mic Off</h4>
     </div><div className="live-class-start-column">
     <h4>Video Off</h4>
     </div><div className="live-class-start-column">
     <h4>Rec Off</h4>
     </div>
     
     </div>
     </div>
        </div></div>
      <div  className="live-class-right ">
      <h1> Electronic Class</h1>
      <div  className="live-class-start-info-bottom ">
      <div className="live-class-start-column">
      <div className="start-class-button">Start Class</div>
     </div>  </div>
      </div>
      
</div></div></div></div></div>
</> :<>

    
    
    </>
}
</>
}
export default LiveClass